var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.5 14.75C4.833 11.817 3 9.106 3 6.618 3 3.618 5.462 1 8.5 1S14 3.618 14 6.618c0 2.488-1.833 5.199-5.5 8.132zm4.4-8.132c0-2.436-2.013-4.518-4.4-4.518-2.387 0-4.4 2.082-4.4 4.518 0 1.936 1.434 4.19 4.4 6.707 2.966-2.516 4.4-4.771 4.4-6.707zM8.5 7.6a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 1.1a2.2 2.2 0 110-4.4 2.2 2.2 0 010 4.4z"
  })));
});
export default SvgLocationicon;